var searchData_json         =   []; // It collects all data product or collection
var collectionHanles_json   =   [];

var collectObjects          =   [];

const col_4_c1  =   /^(0|4|8|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96|100|104|108|112|116|120|124|128|132|136|140|144|148|152|156|160|164|168|172|176|180|184|188|192|196|200|204|208|212|216|220|224|228|232|236|240|244|248|252|256|260|264|268|272|276|280|284|288|292|296|300|304|308|312|316|320|324|328|332|336|340|344|348|352|356|360|364|368|372|376|380|384|388|392|396|400|404|408|412|416|420|424|428|432|436|440|444|448|452|456|460|464|468|472|476|480|484|488|492|496)$/;
const col_4_c2  =   /^(1|5|9|13|17|21|25|29|33|37|41|45|49|53|57|61|65|69|73|77|81|85|89|93|97|101|105|109|113|117|121|125|129|133|137|141|145|149|153|157|161|165|169|173|177|181|185|189|193|197|201|205|209|213|217|221|225|229|233|237|241|245|249|253|257|261|265|269|273|277|281|285|289|293|297|301|305|309|313|317|321|325|329|333|337|341|345|349|353|357|361|365|369|373|377|381|385|389|393|397|401|405|409|413|417|421|425|429|433|437|441|445|449|453|457|461|465|469|473|477|481|485|489|493|497)$/;
const col_4_c3  =   /^(2|6|10|14|18|22|26|30|34|38|42|46|50|54|58|62|66|70|74|78|82|86|90|94|98|102|106|110|114|118|122|126|130|134|138|142|146|150|154|158|162|166|170|174|178|182|186|190|194|198|202|206|210|214|218|222|226|230|234|238|242|246|250|254|258|262|266|270|274|278|282|286|290|294|298|302|306|310|314|318|322|326|330|334|338|342|346|350|354|358|362|366|370|374|378|382|386|390|394|398|402|406|410|414|418|422|426|430|434|438|442|446|450|454|458|462|466|470|474|478|482|486|490|494|498)$/;
const col_4_c4  =   /^(3|7|11|15|19|23|27|31|35|39|43|47|51|55|59|63|67|71|75|79|83|87|91|95|99|103|107|111|115|119|123|127|131|135|139|143|147|151|155|159|163|167|171|175|179|183|187|191|195|199|203|207|211|215|219|223|227|231|235|239|243|247|251|255|259|263|267|271|275|279|283|287|291|295|299|303|307|311|315|319|323|327|331|335|339|343|347|351|355|359|363|367|371|375|379|383|387|391|395|399|403|407|411|415|419|423|427|431|435|439|443|447|451|455|459|463|467|471|475|479|483|487|491|495|499)$/;

const col_3_c1  =   /^(0|3|6|9|12|15|18|21|24|27|30|33|36|39|42|45|48|51|54|57|60|63|66|69|72|75|78|81|84|87|90|93|96|99|102|105|108|111|114|117|120|123|126|129|132|135|138|141|144|147|150|153|156|159|162|165|168|171|174|177|180|183|186|189|192|195|198|201|204|207|210|213|216|219|222|225|228|231|234|237|240|243|246|249|252|255|258|261|264|267|270|273|276|279|282|285|288|291|294|297|300|303|306|309|312|315|318|321|324|327|330|333|336|339|342|345|348|351|354|357|360|363|366|369|372|375|378|381|384|387|390|393|396|399|402|405|408|411|414|417|420|423|426|429|432|435|438|441|444|447|450|453|456|459|462|465|468|471|474|477|480|483|486|489|492|495|498)$/;
const col_3_c2  =   /^(1|4|7|10|13|16|19|22|25|28|31|34|37|40|43|46|49|52|55|58|61|64|67|70|73|76|79|82|85|88|91|94|97|100|103|106|109|112|115|118|121|124|127|130|133|136|139|142|145|148|151|154|157|160|163|166|169|172|175|178|181|184|187|190|193|196|199|202|205|208|211|214|217|220|223|226|229|232|235|238|241|244|247|250|253|256|259|262|265|268|271|274|277|280|283|286|289|292|295|298|301|304|307|310|313|316|319|322|325|328|331|334|337|340|343|346|349|352|355|358|361|364|367|370|373|376|379|382|385|388|391|394|397|400|403|406|409|412|415|418|421|424|427|430|433|436|439|442|445|448|451|454|457|460|463|466|469|472|475|478|481|484|487|490|493|496|499)$/;
const col_3_c3  =   /^(2|5|8|11|14|17|20|23|26|29|32|35|38|41|44|47|50|53|56|59|62|65|68|71|74|77|80|83|86|89|92|95|98|101|104|107|110|113|116|119|122|125|128|131|134|137|140|143|146|149|152|155|158|161|164|167|170|173|176|179|182|185|188|191|194|197|200|203|206|209|212|215|218|221|224|227|230|233|236|239|242|245|248|251|254|257|260|263|266|269|272|275|278|281|284|287|290|293|296|299|302|305|308|311|314|317|320|323|326|329|332|335|338|341|344|347|350|353|356|359|362|365|368|371|374|377|380|383|386|389|392|395|398|401|404|407|410|413|416|419|422|425|428|431|434|437|440|443|446|449|452|455|458|461|464|467|470|473|476|479|482|485|488|491|494|497)$/;

const col_2_c1  =   /^(0|2|4|6|8|10|12|14|16|18|20|22|24|26|28|30|32|34|36|38|40|42|44|46|48|50|52|54|56|58|60|62|64|66|68|70|72|74|76|78|80|82|84|86|88|90|92|94|96|98|100|102|104|106|108|110|112|114|116|118|120|122|124|126|128|130|132|134|136|138|140|142|144|146|148|150|152|154|156|158|160|162|164|166|168|170|172|174|176|178|180|182|184|186|188|190|192|194|196|198|200|202|204|206|208|210|212|214|216|218|220|222|224|226|228|230|232|234|236|238|240|242|244|246|248|250|252|254|256|258|260|262|264|266|268|270|272|274|276|278|280|282|284|286|288|290|292|294|296|298|300|302|304|306|308|310|312|314|316|318|320|322|324|326|328|330|332|334|336|338|340|342|344|346|348|350|352|354|356|358|360|362|364|366|368|370|372|374|376|378|380|382|384|386|388|390|392|394|396|398|400|402|404|406|408|410|412|414|416|418|420|422|424|426|428|430|432|434|436|438|440|442|444|446|448|450|452|454|456|458|460|462|464|466|468|470|472|474|476|478|480|482|484|486|488|490|492|494|496|498)$/;
const col_2_c2  =   /^(1|3|5|7|9|11|13|15|17|19|21|23|25|27|29|31|33|35|37|39|41|43|45|47|49|51|53|55|57|59|61|63|65|67|69|71|73|75|77|79|81|83|85|87|89|91|93|95|97|99|101|103|105|107|109|111|113|115|117|119|121|123|125|127|129|131|133|135|137|139|141|143|145|147|149|151|153|155|157|159|161|163|165|167|169|171|173|175|177|179|181|183|185|187|189|191|193|195|197|199|201|203|205|207|209|211|213|215|217|219|221|223|225|227|229|231|233|235|237|239|241|243|245|247|249|251|253|255|257|259|261|263|265|267|269|271|273|275|277|279|281|283|285|287|289|291|293|295|297|299|301|303|305|307|309|311|313|315|317|319|321|323|325|327|329|331|333|335|337|339|341|343|345|347|349|351|353|355|357|359|361|363|365|367|369|371|373|375|377|379|381|383|385|387|389|391|393|395|397|399|401|403|405|407|409|411|413|415|417|419|421|423|425|427|429|431|433|435|437|439|441|443|445|447|449|451|453|455|457|459|461|463|465|467|469|471|473|475|477|479|481|483|485|487|489|491|493|495|497|499)$/;


const primaryClassForProducts   =   '.searchProductsView';
const productsGridWrap          =   '.gridView';
const gridItem                  =   '._gridItem_';
const itemCard__                =   '.card__';

var productItemsLen, lastAttemptedURL;

var $grid;

$(document).ready(function () {
  try {
    getData();
  } catch( err ) {
    console.log ( 'ERROR ready', err.message );
  }
})

.on('click', '.searchBtnWrapper', function( e ) {
  try {
    e.stopImmediatePropagation();
    const searchForm    =   $( this ).closest( 'form.search' );
    const searchQuery   =   searchForm.find( 'input[type="search"][name="q"]' ).val();
    if ( searchQuery != '' ) {
      searchForm.submit();
    }
  } catch ( err ) {
    console.log ( 'ERROR .searchBtnWrapper', err.message );
  }
})

.on('click', '#SearchDrawer .search-bar__submit.search-form__submit', function( e ) {
  try {
    const searchForm    =   $( this ).closest( 'form.search-form.search-bar__form' );
    const searchQuery   =   searchForm.find( 'input.search-form__input.search-bar__input[name="q"]' ).val();
    if ( searchQuery != '' ) {
      searchForm.submit();
    }
  } catch ( err ) {
    console.log ( 'ERROR #SearchDrawer .search-bar__submit.search-form__submit', err.message );
  }
})
;

async function getData() {
  try {
    const apiUrl  =   $( `${ primaryClassForProducts }` ).attr( 'uri' );
    if ( apiUrl != undefined && apiUrl != '' ) {
      const getResponse   =   await getRequest( `${ apiUrl }` );
      if ( getResponse != undefined && getResponse.resources != undefined && getResponse.resources.results != undefined ) {
        if ( getResponse.resources.results.products != undefined ) {
          const products__      =   getResponse.resources.results.products;
          console.log ( 'products__', products__ );
          const collections__   =   getResponse.resources.results.collections;
          if ( products__.length > 0 ) {
            $( `${ primaryClassForProducts } .notFound` ).remove();
            await makeNewObject( products__ );
            await addDataToPage( newProduct, 'product' );
          }
          if ( collections__ != undefined && collections__.length > 0 ) {
            for ( let i = 0; i < collections__.length; i++ ) {
              const r    =   collections__[i];
              if ( r.handle != undefined && r.handle != '' ) {
                collectionHanles_json.push({
                  handle                :   r.handle,
                  url                   :   `/collections/${ r.handle }?view=jsonData&page=`,
                  page                  :   0,
                  isAvailableNextPage   :   true
                });
              }
            }
            setTimeout(() => {
              getCollectionData();
            },1500);
          }
          if ( products__.length == 0 && collections__.length == 0 ) {
            $( `${ primaryClassForProducts }` )
              .prepend( `<div class="page-width notFound" style="text-align: center;">SORRY NO ITEM FOUND!</div>` )
              .find( `${ productsGridWrap } ${ itemCard__ }.skeleton` )
              .remove();
          }
        }
      }
    }
  } catch ( err ) {
    console.log ( 'ERROR getData', err.message );
  }
}
let wheeldelta = {
  x: 0,
  y: 0
};
let wheeling;
let isFreeToLoad    =   true;
$( document ).scroll(async function () {
  try {
    await require( `${ asset_url }__isInViewport.js` );
    clearTimeout( wheeling );
    wheeling    =   setTimeout(function() {
      wheeling  =   undefined;
      wheeldelta.x = 0;
      wheeldelta.y = 0;
      if ( isFreeToLoad ) {
        isFreeToLoad      =   false;
        const isVisible   =   isInViewport( '.loadMoreElement' );
        if ( isVisible ) {
          getCollectionData();
        } else {
          isFreeToLoad      =   true;
        }
      }
    }, 250);
  } catch ( err ) {
    console.log ( 'ERROR document scroll', err.message );
  }
})
;
async function getCollectionData() {
  try {
    const latestObject  =   await setObjectAndGetData();
    await addDataToPage__( latestObject );
  } catch ( err ) {
    console.log ( 'ERROR getCollectionData', err.message );
  }
}
require( `${ asset_url }__resize.js` );
async function afterResizing() {
  const getLength   =   searchData_json.length;
  const pageWidth   =   $( window ).width();
  const wrapper     =   $( `${ primaryClassForProducts } ${ productsGridWrap }` );
  wrapper.find( '.c1, .c2, .c3, .c4' ).html( `` );
  if ( getLength > 0 ) {
    for ( let i = 0; i < getLength; i++ ) {
      await dataIteration( searchData_json, i, wrapper, pageWidth );
    }
    await afterResizingRemoveLoadingAttr();
  }
}

async function dataIteration( dataArray, i, wrapper, pageWidth, type = '', shouldAddOrNot = '' ) {
  const r           =   dataArray[i];
  const iStr        =   i.toString();
  const duplication =   $( `${ itemCard__ }[handle="${ r.handle }"]`).length;
  if ( duplication == 0 ) {
    const getHTML     =   await cardHTML( r, type, shouldAddOrNot );
    if ( pageWidth > 768 ) {
      if ( iStr.match( col_4_c1 ) ) {
        wrapper.find( '.c1' ).append( getHTML );
      } else if ( iStr.match( col_4_c2 ) ) {
        wrapper.find( '.c2' ).append( getHTML );
      } else if ( iStr.match( col_4_c3 ) ) {
        wrapper.find( '.c3' ).append( getHTML );
      } else if ( iStr.match( col_4_c4 ) ) {
        wrapper.find( '.c4' ).append( getHTML );
      }
    } else if ( pageWidth > 575 && pageWidth < 768 ) {
      if ( iStr.match( col_3_c1 ) ) {
        wrapper.find( '.c1' ).append( getHTML );
      } else if ( iStr.match( col_3_c2 ) ) {
        wrapper.find( '.c2' ).append( getHTML );
      } else if ( iStr.match( col_3_c3 ) ) {
        wrapper.find( '.c3' ).append( getHTML );
      }
    } else if ( pageWidth > 425 && pageWidth < 575 ) {
      if ( iStr.match( col_2_c1 ) ) {
        wrapper.find( '.c1' ).append( getHTML );
      } else if ( iStr.match( col_2_c2 ) ) {
        wrapper.find( '.c2' ).append( getHTML );
      }
    } else {
      wrapper.find( '.c1' ).append( getHTML );
    }
  }
}

async function addDataToPage__( o ) {
  try {
    if ( typeof o !== 'undefined' && o ) {
      console.log ( 'o', o );
      const getLength   =   o.allProducts.length;
      const pageWidth   =   $( window ).width();
      const wrapper     =   $( `${ primaryClassForProducts } ${ productsGridWrap }` );
      if ( getLength > 0 ) {
        for ( let i = 0; i < getLength; i++ ) {
          await dataIteration( o.allProducts, i, wrapper, pageWidth, 'collection', 'add' );
        }
        checkImagesLoaded();
        isFreeToLoad    =   true;
      }
    }
  } catch ( err ) {
    console.log ( 'Error addDataToPage__', err.message );
  }
}

async function setObjectAndGetData() {
  try {
    let iterationNumber   =   0;
    for ( let i = 0; i < collectionHanles_json.length; i++ ) {
      const r             =   collectionHanles_json[i];
      if ( r.isAvailableNextPage ) {
        iterationNumber   =   i;
        break;
      }
    }
    const o               =   collectionHanles_json[iterationNumber];
    const page            =   o.page + 1;
    const url             =   `${ o.url }${ page }`;
    if ( lastAttemptedURL != url ) {
      lastAttemptedURL    =   url;
      console.log ( 'url', url );
      const getObject     =   await getRequestCollection( url );
      const collectionMinusOne    =   collectionHanles_json.length - 1;
      if ( typeof getObject !== 'undefined' && getObject && getObject.isAvailableNextPage !== 'undefined' && getObject.isAvailableNextPage ) {
        collectionHanles_json[iterationNumber].page                 =   page;
        collectionHanles_json[iterationNumber].isAvailableNextPage  =   getObject.isAvailableNextPage;
        if ( collectionMinusOne == iterationNumber && getObject.isAvailableNextPage == false ) {
          if ( typeof noMoreRecordFound !== 'undefined' ) {
            if ( noMoreRecordFound != '' ) {
              $( `.loadMoreElement` ).text( noMoreRecordFound );
              console.log ( 'chaaaa NO MORE RECORD FOUND' );
            }
          }
        }
      }
      return getObject;
    } else {
      return false;
    }
  } catch ( err ) {
    console.log ( 'ERROR setObjectAndGetData', err.message );
  }
}

async function getRequestCollection( url ) {
  try {
    let collectionData__;
    await fetch( url )
    .then(response => response.json())
    .then(data => {
      collectionData__ = data;
    });
    return collectionData__;
  }
  catch ( err ) {
    console.log ( 'ERROR getRequestCollection', err.message );
  }
}

async function makeNewObject( previousObject ) {
  try {
    newProduct    =   [];
    loopLength    =   previousObject.length;
    loopCounter   =   0;
    for (const p_obj of previousObject) {
      const url     =   `/products/${ p_obj.handle }?view=search`;
      newRequest( url );
    }
  } catch ( err ) {
    console.log ( 'ERROR makeNewObject', err.message );
  }
}

async function newRequest( url ) {
  try {
    let newObj;
    await fetch( url )
    .then(response => response.json())
    .then(data => {
      newObj = data;
    });
    newProduct.push( newObj );
    loopCounter++;
    if ( loopCounter == loopLength ) {
      addDataToPage( newProduct, 'product' );
    }
    return newObj;
  } catch ( err ) {
    console.log ( 'ERROR newRequest', err.message );
  }
}

async function getRequest( url, type = '' ) {
  try {
    await fetch( url )
    .then(response => response.json())
    .then(data => {
      collectionData = data;
    });
    return collectionData;
  } catch ( err ) {
    console.log ( 'ERROR getRequest', err.message );
  }
}
async function addDataToPage( o, type__='' ) {
  try {
    const getLength   =   o.length;
    const pageWidth   =   $( window ).width();
    const wrapper     =   $( `${ primaryClassForProducts } ${ productsGridWrap }` );
    if ( getLength > 0 ) {
      for ( let i = 0; i < getLength; i++ ) {
        await dataIteration( o, i, wrapper, pageWidth, type__, 'add' );
      }
      checkImagesLoaded();
    }
  } catch ( err ) {
    console.log ( 'ERROR addDataToPage', err.message );
  }
}

async function cardHTML( o, type__ = '', act = '' ) {
  try {
    if ( act == 'add' ) {
      o.type    =   type__;
      searchData_json.push( o );
    }
    const currencySymbol    =   $( `${ primaryClassForProducts }` ).attr( 'currency-symbol' );
    let price__             =   '';
    if ( o.price == '' && o.min_price == '' ) {
      price__               =   lang__.products.product.sold_out;
    } else {
      price__               =   o.price;
    }
    let exhibition__                  =   'hide';
    if ( typeof o.exhibition !== 'undefined' && o.exhibition && typeof o.exhibitionEndDate !== 'undefined' && o.exhibitionEndDate && typeof o.todayDateForExhibition !== 'undefined' && o.todayDateForExhibition && typeof o.exhibitionStartDate !== 'undefined' && o.exhibitionStartDate ) {
      const startDate             =   new Date( `${ o.exhibitionStartDate }` ).getTime();
      const lastDate              =   new Date( `${ o.exhibitionEndDate }` ).getTime();
      const todayDate             =   new Date( `${ o.todayDateForExhibition }` ).getTime();
      if ( lastDate >= todayDate && startDate <= todayDate ) {
        exhibition__                  =   'show';
      } else if ( lastDate > todayDate && startDate > todayDate ) {
        exhibition__                  =   'hide';
      } else if ( lastDate < todayDate && startDate < todayDate ) {
        exhibition__                  =   'hide';
      }
    }
    return  `
      <div class="card__" handle="${ o.handle }">
        <a href="${ o.url }" class="card__link">
          <div class="card__imgWrap" loading="show">
            <img src="${ o.img }" alt="${ o.title }" class="card__img" loading="lazy">
          </div>
          <div class="card__content">
            <div class="card__vendor" loading="show">${ o.vendor }</div>
            <h3 class="card__title" loading="show">${ o.title }</h3>
            ${ o.exhibition != undefined && o.exhibition != '' ? `
            <div class="card__exhibition ${ exhibition__ }" loading="show">${ o.exhibition }</div>
            ` : `` }
            ${ price__ != '' ? `<div class="card__price" loading="show">
              <span price>${ price__ }</span>
              <span taxes>${ o.tax_content != undefined && o.tax_content != '' ? o.tax_content : '' }</span>
            </div>` : `` }
            ${ o.min_price != '' && o.min_price != lang__.products.product.sold_out ? `
              <div class="card__startFrom" loading="show">
                Prints available<br>
                starting at: ${ o.min_price }
              </div>
            ` : '' }
          </div>
        </a>
      </div>
    `;
  } catch ( err ) {
    console.log ( 'ERROR cardHTML', err.message );
  }
}

function checkImagesLoaded() {
  try {
    const latestLength    =   $( `${ primaryClassForProducts } ${ productsGridWrap } ${ itemCard__ }` ).length;
    if ( productItemsLen == latestLength ) {
      getCollectionData();
    }
    $( `${ itemCard__ } img`).one('load', function() {
      $( this )
        .closest( `${ itemCard__ }` )
        .find( '[loading="show"]' )
        .attr( 'loading', '' );
    }).each(function() {
      if(this.complete) {
        $(this).trigger('load');
      }
    });
    $( `${ itemCard__ }.skeleton` ).remove();
    const inputField          =   $( '.search input[type="search"]' ).val();
    const getTotalSearchCards =   $( `${ productsGridWrap } ${ itemCard__ }` ).length;
    $( 'head title' ).text(`Search results: ${ getTotalSearchCards } results for “${ inputField }” – LoCA.art`);
    $( `${ productsGridWrap } ${ itemCard__ }` ).each( function() {
      const getHandle         =   $( this ).attr( 'handle' );
      const duplication       =   $( `${ productsGridWrap } ${ itemCard__ }[handle="${ getHandle }"]` ).length;
      if ( duplication > 1 ) {
        console.log ( 'This is duplicate', getHandle );
      }
    });
    productItemsLen     =   $( `${ primaryClassForProducts } ${ productsGridWrap } ${ itemCard__ }` ).length;
  } catch ( err ) {
    console.log ( 'ERROR checkImagesLoaded', err.message );
  }
}

async function afterResizingRemoveLoadingAttr() {
  try {
    $( `${ primaryClassForProducts } ${ productsGridWrap } ${ itemCard__ }` ).each(function() {
      $( this ).find( `[loading]` ).attr( `loading`, `` );
    });
  } catch ( err ) {
    console.log ( `ERROR afterResizingRemoveLoadingAttr`, err.message );
  }
}

